export interface DeductionItem {
  id: number;
  amount: number;
  type: DeductionItemType;
  createdAt?: Date;
  updatedAt?: Date;
  payslipId: number;
}

export enum DeductionItemType {
  LATENESS = "LATENESS",
  UNPAID_LEAVE = "UNPAID_LEAVE",
}

export const DeductionItemTypeLabels: { [key in DeductionItemType]: string } = {
  [DeductionItemType.LATENESS]: "Lateness",
  [DeductionItemType.UNPAID_LEAVE]: "Unpaid Leave",
};
